<style>
.verify-popup {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.8);
    top: 0;
    left: 0;
    z-index:98;
    overflow:hidden;
}
.verify-popup-inner h3 {
    color: #000;
    font-size: 20px;
    margin-bottom:20px;
    text-align:center;
    font-weight: 600;
    text-transform: uppercase;
}
.bottom-buttons{margin-top:10px;}
.verify-popup-inner {
    width: 500px;
    background: #ffffff;
    margin:65px auto 0;
    border-radius: 5px;
    padding: 1em 2em;
}
button.verifyBtn {
    background: #E88018;
    border: none;
    padding: 7px 20px;
    border-radius: 3px;
    color: #fff;
    text-transform: uppercase;
    margin-top: 10px;
}
.verify-popup-inner .logo_congrats {
    width: 75px;
    height: 75px;
}
.verify-popup-inner .logo_congrats img {
    max-width: 50px;
}
.verify-link input.form-control {
    background: none;
    border-color: #ddd;
    color: #000;
    box-shadow: none!important;
}
.verify-link input.form-control:hover, .verify-link input.form-control:focus {
    border-color:var(--theme-yellow);
    box-shadow: none;
}
.verify-link a {
    color: #5f5c5c;
    margin-top:6px;
}
.verify-link a i.feather svg{
	margin-left: 5px;
    top: 2px;
    height: 14px;
    width:14px;
}
.verify-link a:hover{
	color:var(--theme-yellow);
}
</style>
<template>
    <div data-gr-c-s-loaded="true" cz-shortcut-listen="true">
        <loader v-if="pageLoader"></loader>
        <app-header ></app-header>
        <router-view />
        <app-footer ></app-footer>
        <div class="verify-popup" v-if="parseInt(get_user.profile.account_verified) == 0"> 
        	<div class="verify-popup-inner">
                <h3>Verify your account</h3>
                <h4 v-if="message">{{ message }}</h4>
        		<div class="logo_congrats mt-4 mx-auto">
					<img src="../../../static/ibcoinexx/img/otp-main.svg" width="" alt="Icon">
				</div>
        		<div class="verify-link mb-5">
				    <input type="text" placeholder="Type your 6 digit OTP..." class="form-control mb-2" v-model="otp" name="otp" v-validate="'required|numeric|max:6'">
					<span v-show="submitted && errors.has('otp')" class="text-danger">{{ errors.first('otp') }}</span>
				    <div class="resend-otp"><a href="#" clsas="" @click="resendOtp()">Resend OTP. <feather type="refresh-cw" size="1em" class=" custom-class secondIcon"></feather></a></div>
				</div>
        		<div class="bottom-buttons d-flex-align-between">
        			<button class="verifyBtn" v-on:click="otpFunc()">Submit</button>
				    <button class="verifyBtn red-bg" @click="logout()">Logout</button>
        		</div>
        	</div>
        </div>
    </div>
</template>

<script>

	
import Header from './shared/header'
import Footer from './shared/footer'
import * as types from '../../types'
import { fxViewMixins } from '@/plugins/fxView'
import { mapActions } from 'vuex'

import moment from 'moment'

export default {
    name: 'Index',   
    mixins: [fxViewMixins],
    components: {
      appHeader: Header,
     appFooter: Footer

    },
    data () {
        return {
            pageLoader : false,
            submitted : false,
            otp : '',
            message : ''
        }
    },
    methods:{
        ...mapActions({
            _runOtpFunc: types.RUN_VERIFY_OTP,
            _runResendOtp: types.RUN_RESEND_OTP,
            _runUserLogout: types.RUN_USER_LOGOUT
        }),
        dateDDMMFormat(dateVal){
            return moment(dateVal).format('DD-MM-YYYY h:mm:ss')
        },
        logout(){
            localStorage.setItem("last_route", this.$route.path)
            let input_json={
                'globalParams' :{},
                'localParams' :{
                    "parameter" : this
                }
            }
            this._runUserLogout(input_json)
        },
        resendOtp: function() {
            let input_json={
                'globalParams' :{
                    
                },
                'localParams' :{ "parameter" : this }
            }
            this._runResendOtp(input_json)
        },
        reset(){
            this.submitted = false
            this.otp = ''
        },
        otpFunc: function() {
            const _that = this
            _that.submitted = true;
            this.$validator.validate().then(valid => {
                if (valid){
                    let input_json={
                        'globalParams' :{
                            "otp": _that.otp
                        },
                        'localParams' :{ "parameter" : _that }
                    }
                    _that._runOtpFunc(input_json)
                }
            });
        }
    },
	mounted () {
    },
	created() {
		this.$store.dispatch(types.RUN_STATE_LOAD)
	}
}
</script>




// WEBPACK FOOTER //
// src/components/fxView/index.vue